const EARTH_RADIUS_KM = 6371;

const toRad = (deg) => deg * Math.PI / 180;

export function getDistanceKm(from, to) {
  if (!from || !to) {
    return Infinity;
  }
  const dLat = toRad(to.lat - from.lat);
  const dLng = toRad(to.lng - from.lng);
  const a = Math.sin(dLat / 2) ** 2
    + Math.cos(toRad(from.lat)) * Math.cos(toRad(to.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * EARTH_RADIUS_KM * Math.asin(Math.min(1, Math.sqrt(a)));
}
